module.exports = __webpack_public_path__ + "img/portfolio-big-02.8dee6369.jpg";